<template>
  <div id="app" dir="rtl">
    <v-app>
      <AppBar />
      <NavigationDrawer ref="navigationDrawer" />
      <v-main>
        <router-view />
      </v-main>
      <Footer />
    </v-app>
  </div>
</template>

<script>
import NavigationDrawer from './components/NavigationDrawer.vue'
import AppBar from './components/AppBar.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',

  components: {
    NavigationDrawer,
    AppBar,
    Footer,
  },

  methods: {
    // No longer need toggleDrawer since drawer is always visible
  },
}
</script>

<style lang="scss">
@import '~/assets/scss/main.scss';
@import 'https://ibdok.ir/cdn/fontiran-VNXMNSAT.css';
@import '~/assets/scss/vuetify';

#app {
  font-family: 'IRANSans', Arial, sans-serif;
  direction: rtl;
  text-align: right;
}

.v-application {
  font-family: 'IRANSans', Arial, sans-serif !important;
  direction: rtl !important;
}

.v-main {
  padding-top: 64px !important; // Account for fixed app bar
}

// Right-positioned Navigation Drawer
.v-navigation-drawer {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-left: none !important;
}

// Ensure proper RTL layout for all components
.v-application--is-rtl {
  .v-navigation-drawer {
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
    border-left: none !important;
  }
}

.v-app-bar {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

// RTL text alignment
.v-list-item-title,
.v-toolbar-title,
.v-card-title,
.v-data-table th,
.v-data-table td {
  text-align: right !important;
}

// Fix icon positioning in RTL
.v-list-item-icon {
  margin-left: 12px !important;
  margin-right: 0 !important;
}

// Ensure proper spacing for RTL
.v-btn {
  .v-icon--left {
    margin-left: 8px !important;
    margin-right: 0 !important;
  }
  .v-icon--right {
    margin-right: 8px !important;
    margin-left: 0 !important;
  }
}

// Mobile responsive adjustments - drawer is now always permanent
@media (max-width: 959px) {
  .v-navigation-drawer {
    // Keep drawer visible on all screen sizes
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  }
}
</style>
